import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import { LANDING_HOME_LINKS } from '../landing/templates';
import './ErrorPage.css';

const VARIANTS = {
  404: {
    eyebrow: 'Error 404',
    title: 'Page not found',
    lead:
      "The page you're looking for doesn't exist, was renamed, or the link is broken. Check the address, or jump back into a generator below.",
    quickLinks: LANDING_HOME_LINKS.slice(0, 4),
  },
  500: {
    eyebrow: 'Error 500',
    title: 'Something went wrong',
    lead:
      'An unexpected error interrupted this page. Try again, or let us know if it keeps happening.',
    quickLinks: [],
  },
};

function ArrowIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M6 2L2 8l4 6M2 8h12" />
    </svg>
  );
}

export default function ErrorPage({ code = 404, onReset }) {
  const variant = VARIANTS[code] || VARIANTS[404];
  const isServer = code === 500;

  return (
    <div className="app err-page">
      <SiteNav />
      <main className="err-main">
        <div className="err-grid" aria-hidden="true" />
        <div className="err-card">
          <p className="err-eyebrow">{variant.eyebrow}</p>
          <div className="err-code" aria-hidden="true">{code}</div>
          <h1 className="err-title">{variant.title}</h1>
          <p className="err-lead">{variant.lead}</p>

          <div className="err-actions">
            {isServer && onReset && (
              <button type="button" className="err-btn err-btn-primary" onClick={onReset}>
                Try again
              </button>
            )}
            <a className={`err-btn ${isServer && onReset ? 'err-btn-secondary' : 'err-btn-primary'}`} href="/">
              <ArrowIcon />
              Back to home
            </a>
            <a className="err-btn err-btn-secondary" href="/contact">
              Contact us
            </a>
          </div>

          {variant.quickLinks.length > 0 && (
            <div className="err-links">
              <span className="err-links-label">Popular generators</span>
              <div className="err-links-row">
                {variant.quickLinks.map((l) => (
                  <a className="err-link" href={l.path} key={l.path}>
                    {l.title}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
